import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import Pagination from '@/components/Pagination/index.vue';
import { downloadWithNewWindow } from '@/common/download.js';
import TableList from '@/components/TableList/index.vue';
import { grantBalanceList } from '@/api/grant/grant';
import { statusOptions } from '@/common/permission';
import SearchBar from '@/components/SearchV3/index.vue';
import { testList } from '@/views/producer/common-template/selling-strategy.js';
import { fmtThousands } from '@com/utils/data-format';
import searchMixin from '@/mixin/search';
import { v2Host } from '@/config/host';
import _ from 'lodash';
import qs from 'qs';

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      listLoading: true,
      pagination: {
        total: 0
      },
      query: {
        adv_id: undefined,
        adv_name: '',
        is_test: '',
        page: 1,
        page_size: 15
      },
      // 表单数据
      list: [],
      statusOptions: statusOptions
    };
  },

  computed: {
    exportButtonAttrs: function exportButtonAttrs() {
      return {
        icon: 'el-icon-fa-download',
        type: 'primary'
      };
    },
    formItemList: function formItemList() {
      return [{
        type: 'input',
        prop: 'adv_id',
        params: {
          clearable: true,
          placeholder: '请输入广告主ID'
        }
      }, {
        prop: 'adv_name',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          multiple: true,
          filterable: true,
          collapseTags: true,
          valueKey: 'name',
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }, {
        prop: 'is_test',
        type: 'select',
        params: {
          placeholder: '是否测试账号',
          clearable: true,
          options: testList
        }
      }];
    },
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '广告主ID',
        prop: 'adv_id'
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '是否测试账号',
        prop: 'is_test',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            var temp = testList.find(function (s) {
              return s.value === row.is_test;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '账户余额',
        prop: 'balance',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return row.balance ? fmtThousands(row.balance) : '-';
          }
        }
      }, {
        label: '最低余额',
        prop: 'min_amount',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return row.min_amount ? fmtThousands(row.min_amount) : '-';
          }
        }
      }, {
        label: '累计充值金额',
        prop: 'total_recharge',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            return row.total_recharge ? fmtThousands(row.total_recharge) : '-';
          }
        }
      }, {
        label: '累计账单金额',
        prop: 'total_bill',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            return row.total_bill ? fmtThousands(row.total_bill) : '-';
          }
        }
      }, {
        label: '累计欠款金额',
        prop: 'total_arrears_bill',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            return row.total_arrears_bill ? fmtThousands(row.total_arrears_bill) : '-';
          }
        }
      }];
    }
  },
  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query.page = 1;
      }
      this.getBalanceList(this.query);
    }
  },
  methods: {
    exportSheet: function exportSheet() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  downloadWithNewWindow(v2Host + '/grant/export-account-balance?' + qs.stringify(_this.query));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBalanceList: function getBalanceList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var new_params, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                new_params = _.cloneDeep(params);

                if (!(new_params.adv_id !== undefined && new_params.adv_id !== '')) {
                  _context2.next = 6;
                  break;
                }

                new_params.adv_id = Number(new_params.adv_id);

                if (!isNaN(new_params.adv_id)) {
                  _context2.next = 6;
                  break;
                }

                _this2.$message.error('广告主id必须填写数字');
                return _context2.abrupt('return');

              case 6:
                _context2.prev = 6;

                _this2.listLoading = true;
                _context2.next = 10;
                return grantBalanceList(_extends({}, new_params));

              case 10:
                res = _context2.sent;

                _this2.listLoading = false;

                if (!(res.status !== 200)) {
                  _context2.next = 15;
                  break;
                }

                _this2.$message.error('出错了');
                return _context2.abrupt('return');

              case 15:
                _this2.list = _.get(res, 'data.data.list') || [];
                _this2.pagination.total = _.get(res, 'data.data.total');
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](6);

                _this2.listLoading = false;

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[6, 19]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.getBalanceList(_this3.query);

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};